// Module frontend surface.
//
// The shell discovers this file automatically (modules/*/frontend/index.js) and
// merges what it exports. Adding this module needs no edit to the shell.
//
// Five routes for four jobs, and the split is by what somebody came to do:
// read the numbers, ask a question, keep a question, or look at one customer.
// There is no route per module — the tabs of the first screen are the analytics
// catalogue, which is a list nobody writes down.

// With the extension, and it matters: Vite resolves './i18n/es' happily, but
// Node's ESM loader does not — and the shell's i18n guard imports this file with
// plain Node. Without the four characters the module's translations are
// invisible to the test that exists to check them.
import es from './i18n/es.js'
import ca from './i18n/ca.js'
import en from './i18n/en.js'
import fr from './i18n/fr.js'

export const routes = [
  {
    path: '/reports',
    name: 'reports',
    component: () => import('./pages/ReportsPage.vue'),
    meta: { permission: 'reports:read', title: 'reports.title' },
  },
  // Before /:id in the file for the reader; route ranking would put the static
  // paths first anyway.
  {
    path: '/reports/explore',
    name: 'reports-explore',
    component: () => import('./pages/ExplorePage.vue'),
    meta: { permission: 'reports:read', title: 'reports.explore.title' },
  },
  {
    path: '/reports/saved',
    name: 'reports-saved',
    component: () => import('./pages/SavedReportsPage.vue'),
    meta: { permission: 'reports:read', title: 'reports.saved.title' },
  },
  /**
   * Everything the ERP knows about one record (§78).
   *
   * The type is a path segment and not a query parameter because it is part of
   * WHAT this page is: `/reports/entity/customer/abc` is a customer's figures,
   * and it is a link somebody sends to a colleague.
   */
  {
    path: '/reports/entity/:type/:id',
    name: 'reports-entity',
    component: () => import('./pages/EntityReportPage.vue'),
    meta: { permission: 'reports:read', title: 'reports.entity.subtitle' },
  },
  {
    path: '/reports/:id',
    name: 'report',
    component: () => import('./pages/ReportPage.vue'),
    meta: { permission: 'reports:read', title: 'reports.title' },
  },
]

/**
 * One row with two children.
 *
 * Everything behind `reports:read`, deliberately: saving a report and putting
 * one on a clock are rights, but the SCREENS are the same screens, and a
 * sidebar entry that disappears for somebody who can read reports but not save
 * them would hide the shelf from the person who reads the most.
 */
export const navigation = [
  {
    to: '/reports',
    labelKey: 'reports.title',
    permission: 'reports:read',
    icon: 'chart',
    group: 'business',
    children: [
      { to: '/reports/explore', labelKey: 'reports.explore.title', permission: 'reports:read' },
      { to: '/reports/saved', labelKey: 'reports.saved.title', permission: 'reports:read' },
    ],
  },
]

// Strings this module contributes, merged per locale. Four languages from the
// first commit (§16): a module that ships two is a module that cannot be sold
// to the third client. That includes what this module is called on the
// PLATFORM's own screens — Roles, Settings, Audit, the outgoing-mail routing
// and the assistant panel — because a module that makes somebody add keys to
// the shell is not extractable.
// What the assistant panel says while this module's tools run: another
// contract with the backend (backend/assistant.js), in its own file.
import { withToolLabels } from './i18n/toolLabels.js'

export const messages = withToolLabels({ es, ca, en, fr })
